import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { getAppTheme } from "./theme/themeConfig";
import CssBaseline from "@mui/material/CssBaseline";
import "./index.css";
import { Provider, useSelector } from "react-redux";
import App from "./App";
import store from "./store/store";
import ToastConfig from "./config/toastConfig";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// Theme wrapper component that reads darkmode from REDUX (not useDarkMode hook)
const ThemedApp = () => {
  // Read darkmode from Redux store instead of useDarkMode hook
  const darkmode = useSelector((state) => state.theme?.darkmode ?? false);

  // Generate MUI theme from our central config based on darkmode state
  const theme = getAppTheme(darkmode);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
        <ToastConfig />
      </ThemeProvider>
    </LocalizationProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <Provider store={store}>
      <ThemedApp />
    </Provider>
  </BrowserRouter>
);
